namespace Solovis.Reports.Parameters {

    export class StringParameterControl extends Solovis.UI.BaseControl {

        public initialParameterValue;
        public textInput: JQuery;


        constructor(options) {
            super(options);

            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : false;
        }


        public static getLabel(value): string | undefined {
            return value;
        }

        public doInit() {
        }

        public doRender() {
            var self = this;

            this.textInput = $("<input>").attr("type", "text").appendTo(this.container);

            if (this.initialParameterValue !== null) {
                this.textInput.val(this.initialParameterValue);
            }

            $(this.textInput).change(function () {
                self.notifyParameterValueChanged();
            });
        }


        public setParameterValue(newValue, more) {
            Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
                this, StringParameterControl, this._setCurrentTextValue, newValue, more);
        };

        public _setCurrentTextValue(newValue) {
            if (this.textInput) {
                this.textInput.val(newValue);
            }
            else {
                this.initialParameterValue = newValue;
            }
        }

        public getParameterValue() {
            if (this.textInput) {
                var textValue = this.textInput.val();
                return textValue;
            }
            else {
                return this.initialParameterValue;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }
    }       

}
